/**
 * Ahlam custom cursor — gold dot with lerp follow.
 * Scales on hover over interactive elements. Skipped on touch / reduced motion.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const init = () => {
    if (document.getElementById('ahlam-cursor')) return;

    const dot = document.createElement('div');
    dot.id = 'ahlam-cursor';
    document.body.appendChild(dot);

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let dx = mx;
    let dy = my;

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
    };

    document.addEventListener('mousemove', onMove, { passive: true });

    const tick = () => {
      dx += (mx - dx) * 0.18;
      dy += (my - dy) * 0.18;
      dot.style.transform = `translate3d(${dx - 6}px, ${dy - 6}px, 0)`;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    const interactiveSelector =
      'a, button, [role="button"], .product-card, .button, input[type="submit"], summary, label, .quick-add__button';

    document.addEventListener(
      'mouseover',
      (e) => {
        const target = e.target;
        if (target && target.closest && target.closest(interactiveSelector)) {
          dot.classList.add('is-hover');
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'mouseout',
      (e) => {
        const target = e.target;
        if (target && target.closest && target.closest(interactiveSelector)) {
          dot.classList.remove('is-hover');
        }
      },
      { passive: true }
    );

    // Hide cursor when mouse leaves window, restore on return
    document.addEventListener('mouseleave', () => {
      dot.style.opacity = '0';
    });
    document.addEventListener('mouseenter', () => {
      dot.style.opacity = '';
    });
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
